import React from 'react'
import useSWRMutation from 'swr/mutation'

import { addInterviewFeedback } from '../../../api/user-feedback'
import Loading from '../../components/layout/Loading'
import ErrorMessage from '../../components/errors/ErrorMessage'
import FeedbackForm from '../../components/user-feedback/FeedbackForm'
import { UserFeedback } from '../../../api/user-feedback/types'
import { useToaster } from '../../../libraries/toaster'
import { useI18N } from '../../../libraries/i18n/hook'

type Props = { interviewId: number, question?: string | null, status: object, iconColor?: string }
const InterviewAiFeedback: React.FC<Props> = ({ interviewId, question, status, iconColor = 'white' }) => {
  const { showSuccess } = useToaster()
  const { t } = useI18N()

  const { trigger: triggerAddFeedback, isMutating, error: addFeedbackError } = useSWRMutation(
    `/interview/${interviewId}/feedback`,
    addInterviewFeedback,
    { onSuccess: () => { showSuccess(t('ai.user.feedback.saved')) } },
  )

  const handleSubmit = async(feedback: UserFeedback) => {
    await triggerAddFeedback({ interviewId, question, status, ...feedback })
  }

  if(isMutating) { return <Loading /> }
  if(addFeedbackError) { return <ErrorMessage message='Error adding interview feedback' /> }

  return <FeedbackForm onSubmit={handleSubmit} iconColor={iconColor} />
}

export default InterviewAiFeedback
